
import { Component, Vue } from 'vue-property-decorator';
import SAccProjectsList from "@/components/projects/SAccProjectsList.vue";
import { ProjectDocument } from "@/interfaces/project.interfaces";
import { createProject, fetchProjects, updateProject } from "@/axios/axios.project";
import { UserDocumentFlat } from "@/interfaces/user.interfaces";
import SAccProjectSheet from "@/components/projects/SAccProjectSheet.vue";
import SAccCopyRepo from "@/components/projects/dialog/SAccCopyRepo.vue";

@Component({
  components: {SAccCopyRepo, SAccProjectSheet, SAccProjectsList}
})
export default class SAccProjects extends Vue {
  // Les props
  // Les propriétés
  private loading: boolean = false
  private projects: ProjectDocument[] = []
  private currentProject: ProjectDocument | null = null
  private search: string = ''

  // Les propriétés calculées
  private get projectQuota(): string {
    const pq = this.$store.getters['projectQuota']
    return pq === 1 ? '1 repository' : `${pq} repositories`
  }

  private get usedQuota(): number {
    const np = this.projects.filter(p => p.active)
    return np.length
  }

  // Les hooks
  public mounted() {
    this.$store.commit('setWorkspace', 'Repository management')
    this.loadProjects()
  }

  // Les méthodes surveillées
  // Les méthodes d'instance
  private async loadProjects() {
    this.loading = true
    this.projects = await fetchProjects()
    this.loading = false
  }

  private async onChange(body: Partial<UserDocumentFlat>) {
    if (this.currentProject) {
      this.loading = true
      const prj = await updateProject(this.currentProject._id, body)
      await this.loadProjects()
      this.currentProject = prj
    }
  }

  private async onDeletedProject() {
    await this.loadProjects()
    this.currentProject = null
  }

  private async onAddProject() {
    const prjDoc = await createProject({
      name: 'new Repository',
      strictMode: true
    })
    await this.updateProjectList(prjDoc)
  }

  private async updateProjectList(prjDoc: ProjectDocument | null) {
    await this.loadProjects()
    this.currentProject = prjDoc
  }

  // Les méthodes statiques
}
